import { FC } from 'react';
// components
import VeganTypeRadioGroup from 'components/main/Formulas/Dosage/Add/components/VeganTypeRadioGroup';

const AllOthers: FC = () => <VeganTypeRadioGroup />;

export default AllOthers;
